var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"status",class:_vm.status},[_c('p',{staticClass:"flex items-center"},[(_vm.icon)?_c('i',{staticClass:"text-13",class:_vm.icon}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }